import { render, staticRenderFns } from "./mobile-header-body.vue?vue&type=template&id=382255cd&scoped=true"
import script from "./mobile-header-body.vue?vue&type=script&lang=js"
export * from "./mobile-header-body.vue?vue&type=script&lang=js"
import style0 from "./mobile-header-body.vue?vue&type=style&index=0&id=382255cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382255cd",
  null
  
)

export default component.exports